<template>
  <div>
    <!--  https://developers.google.com/search/docs/advanced/structured-data/generate-structured-data-with-javascript?ref=madewithvuejs.com  -->
    <!--  google seo crawlernek review meta adatok. ki tudja innen olvasni js betöltéssel is  -->
    <div
      v-if="metaData !== null"
      itemscope
      itemtype="https://schema.org/Product"
    >
      <meta
        v-if="metaData.product.sku !== null"
        itemprop="sku"
        :content="metaData.product.sku"
      >
      <meta v-if="metaData.product.gtin14 !== ''" itemprop="gtin14" :content="metaData.product.gtin14" />
      <meta itemprop="category" :content="metaData.product.category" />
      <meta itemprop="name" :content="metaData.product.name" />
      <meta itemprop="description" :content="metaData.product.description" />
      <meta itemprop="image" :content="metaData.product.image" />
      <span itemprop="offers" itemscope itemtype="https://schema.org/Offer">
        <meta itemprop="url" :content="metaData.product.offers.url" />
        <meta itemprop="priceCurrency" :content="metaData.product.offers.priceCurrency" />
        <meta itemprop="price" :content="metaData.product.offers.price" />
        <meta itemprop="priceValidUntil" :content="metaData.product.offers.priceValidUntil" />
        <link itemprop="availability" :href="metaData.product.offers.availability"/>
        <link itemprop="itemCondition" href="https://schema.org/NewCondition" />
      </span>
      <span itemprop="brand" itemscope itemtype="https://schema.org/Brand">
        <meta itemprop="logo" :content="metaData.product.brand.logo" />
        <meta itemprop="name" :content="metaData.product.brand.name" />
        <meta itemprop="url" :content="metaData.product.brand.url" />
      </span>
      <template v-if="'aggregateRating' in metaData.product">
        <div
          itemprop="aggregateRating"
          itemscope
          itemtype="https://schema.org/AggregateRating"
        >
          <meta itemprop="ratingValue" :content="metaData.product.aggregateRating.ratingValue" />
          <meta itemprop="reviewCount" :content="metaData.product.aggregateRating.reviewCount" />
          <meta itemprop="bestRating" content="5" />
          <meta itemprop="worstRating" content="1" />
        </div>
        <div
          v-for="review in metaData.reviewList"
          :key="review.id"
          itemscope
          itemprop="review"
          itemtype="https://schema.org/Review"
        >
          <meta itemprop="itemReviewed" :content="review.productName">
          <meta itemprop="datePublished" :content="review.date">
          <meta itemprop="reviewBody" :content="review.text">
          <span
            itemscope
            itemprop="author"
            itemtype="https://schema.org/Person"
          >
            <meta itemprop="name" :content="review.userName" >
          </span>
          <div
            class="oneReview"
            itemprop="reviewRating"
            itemscope
            itemtype="https://schema.org/Rating"
          >
            <span
              itemscope
              itemprop="author"
              itemtype="https://schema.org/Person"
            >
              <meta itemprop="name" :content="review.userName" >
            </span>
            <meta itemprop="ratingValue" :content="review.ratingValue">
            <meta itemprop="worstRating" content="1">
            <meta itemprop="bestRating" content="5">
          </div>
        </div>
      </template>
    </div>
    <sticky-product-card
      v-if="product"
      :product="product"
    />
    <loading-indicator
      v-if="product === null"
      :is-full-page="true"
    />
    <div
      v-else
      class="container container-small"
    >
      <div class="mt-5 d-flex justify-content-center">
        <rating-stars
          :rating="productRateValue"
          :is-rate-num-visible="false"
          :is-review-count-visible="false"
        />
      </div>
      <h1
        class="page-title text-center my-5"
      >
        {{ $t('termek_vasarloi_velemenyek') }} {{ productRateValue }} ({{ reviewCount }})
      </h1>
      <div class="container-small container">
        <review-bar
          v-for="reviewBar in reviewBarData"
          :key="reviewBar.starCount"
          :star-count="reviewBar.starCount"
          :percent="reviewBar.percent"
          :is-disabled="!canFilterCurrentStar(reviewBar.starCount) || reviewBar.percent === 0"
          :is-active="reviewStarFilter !== '' && reviewStarFilter === reviewBar.starCount"
          class="my-3 cursor-pointer"
          @reviewBarClicked="selectStarFilter"
        />
      </div>
      <div v-t="'orszag'" />
      <div class="d-flex my-4">
        <flag
          v-for="langData in langFilterList"
          :key="langData.langKey"
          :flag-img-src="langData.flagImgSrc"
          :lang-key="langData.langKey"
          :is-large="true"
          class="mr-3 cursor-pointer flag-block"
          :is-active="reviewLangFilter !== '' && reviewLangFilter === langData.langKey"
          :is-disabled="!canFilterCurrentLang(langData.langKey)"
          @flagClicked="selectLangFilter"
        />
      </div>
      <div class="text-center">
        <button
          v-if="reviewStarFilter !== '' || reviewLangFilter !== ''"
          class="custom-button unfilled mb-1 mt-3 review-page-btn"
          v-t="'clear_review_filter'"
          @click="clearReviewFilters"
        />
      </div>
      <div
        v-if="isLoggedIn"
        class="text-center"
      >
        <div
          v-if="unAcceptedReviewList.length === 0"
        >
          <button
            v-if="!isWritingReview"
            class="custom-button mb-5 mt-3 review-page-btn"
            v-t="'en_is_elmondom_a_velemenyem'"
            @click="isWritingReview = true"
          />
          <div
            v-else
            class="new-review-block mb-4"
          >
            <div>
              <div
                ref="viewOpinion"
                v-t="'ertekeld_csillagokkal'"
              />
              <div class="d-flex justify-content-center my-3">
                <rating-stars
                  :is-rating-enabled="true"
                  :latest-star-clicked="selectedStarForReview"
                  :is-rate-num-visible="false"
                  :is-review-count-visible="false"
                  @rateClicked="selectStarForReview"
                />
              </div>
            </div>
            <custom-input
              v-model="reviewTitle"
              :title-name="$t('velemeny_inputtext_placeholder')"
              data-cy="review-title"
            />
            <textarea
              v-model="reviewText"
              :placeholder="$t('velemeny_textarea_placeholder')"
              data-cy="review-body"
            />
            <div class="custom-control custom-checkbox ml-4 text-left mt-2">
              <input
                id="moderation-accept-checkbox"
                v-model="isModerationAccepted"
                type="checkbox"
                class="custom-control-input"
              >
              <label class="custom-control-label" for="moderation-accept-checkbox">
                <text-and-widget-display :text-body="$t('moderation_note')" />
              </label>
            </div>
            <button
              v-t="'term_kerdesek_elkuld'"
              :disabled="isReviewAddInProgress || reviewText.trim() === '' || !isSelectedStarValid || !isModerationAccepted"
              class="custom-button mt-3"
              data-cy="review-send"
              @click="addReview"
            />
          </div>
        </div>
        <div v-else>
          <div
            v-for="unAcceptedReviewData in unAcceptedReviewList"
            :key="unAcceptedReviewData.ID"
            class="text-left my-4"
          >
            <product-review-card
              :review-data="unAcceptedReviewData"
              class="my-2"
            />
            <hr>
          </div>
          <div
            class="text-center mb-5"
            v-t="'legy_turelemmel_velemeny'"
          />
        </div>
      </div>
      <div v-else class="text-center mb-5">
        <router-link to="/login">
          <button
            ref="loginToOpinion"
            v-t="'login_to_review_item'"
            class="custom-button mt-3"
          />
        </router-link>
      </div>
      <h3
        v-if="!isLoadInProgress && productReviewList.length === 0"
        v-t="'nincs_megjelenitheto_tartalom'"
        class="text-center"
      />
      <div v-else>
        <div
          v-for="reviewData in productReviewList"
          :key="reviewData.ID"
        >
          <product-review-card
            :review-data="reviewData"
            :is-vote-in-progress="voteProgresses[reviewData.ID] === true"
            @voteReview="voteReview"
            @translationClicked="translateReview"
          />
          <hr>
        </div>
      </div>
      <div class="text-center my-5">
        <loading-indicator
          v-if="isLoadInProgress"
          :is-full-page="true"
        />
        <div
          v-else-if="isMoreReviewAvailable"
          v-observe-visibility="onListEndVisible"
          class="text-center load-more-btn"
        >
          <span v-t="'others'" class="cursor-pointer" @click="loadProductReviews" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import { mapGetters } from 'vuex'
import { NOTY_TYPE } from '../../constant/builderConsts.js'
import Vue from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility'

Vue.directive('observe-visibility', ObserveVisibility)

export default {
  name: 'productReviews',
  components: {
    'text-and-widget-display': () => import(/* webpackChunkName: "textAndWidgetDisplay" */ '../../components/textAndWidgetDisplay/textAndWidgetDisplay.vue'),
    'product-review-card': () => import(/* webpackChunkName: "productReviewCard" */ '../../components/productReviewCard/productReviewCard.vue'),
    'loading-indicator': () => import(/* webpackChunkName: "LoadingIndicator" */ '../../components/LoadingIndicator/LoadingIndicator.vue'),
    'sticky-product-card': () => import(/* webpackChunkName: "stickyProductCard" */ '../../components/stickyProductCard/stickyProductCard.vue'),
    'flag': () => import(/* webpackChunkName: "flag" */ '../../components/flag/flag.vue'),
    'review-bar': () => import(/* webpackChunkName: "reviewBar" */ '../../components/reviewBar/reviewBar.vue'),
    'rating-stars': () => import(/* webpackChunkName: "RatingStars" */ '../../components/RatingStars/RatingStars.vue'),
    'custom-input': () => import(/* webpackChunkName: "customInput" */ '../../components/customInput/customInput.vue'),
  },
  data() {
    return {
      /**
       * folyamatban van-e termék kérdés lista betöltés
       */
      isLoadInProgress: false,
      /**
       * is review vote in progress
       *
       * @type {boolean}
       */
      isVoteInProgress: false,
      voteProgresses: {},
      /**
       * moderáció el van-e fogadva
       *
       * @type {Boolean}
       */
      isModerationAccepted: false,
      /**
       * termék a lebegő cimkéhez
       */
      product: null,
      /**
       * termék kérdések száma
       */
      reviewCount: 0,
      /**
       * termék összesitett értékelés száma
       */
      productRateValue: 0,
      /**
       * termék kérdések listája
       */
      productReviewList: [],
      /**
       * nyelv filter lista
       */
      langFilterList: [],
      /**
       * seohoz szükséges adatok
       *
       * null -> még nincs inicializálva
       *
       * @type {{
       *   reviewList: [{
       *     id: Number,
       *     productName: String,
       *     date: String,
       *     text: String,
       *     userName: String,
       *     ratingValue: String,
       *   },],
       *   product: {
       *     sku: String,
       *     gtin14: String,
       *     name: String,
       *     category: String,
       *     description: String,
       *     image: String,
       *     offers: {
       *       url: String,
       *       priceCurrency: String,
       *       price: String,
       *       availability: String,
       *       priceValidUntil: String,
       *     },
       *     brand: {
       *       logo: String,
       *       name: String,
       *       url: String,
       *     },
       *     aggregateRating: {
       *       ratingValue: Number,
       *       reviewCount: Number,
       *       itemReviewedType: String,
       *     }|undefined,
       *   },
       * }}
       */
      metaData: null,
      /**
       * csillag adatok a százalékos bar-hoz
       */
      reviewBarData: [],
      /**
       * jelengleg választható bar filter lista
       */
      availableStarFilterList: [],
      /**
       * jelengleg választható nyelv filter lista
       */
      availableLangFilterList: [],
      /**
       * user nem megválaszolt kérdéseinek listája
       */
      unAcceptedReviewList: [],
      /**
       * van-e még review amit betölthetünk
       */
      isMoreReviewAvailable: false,
      /**
       * aktiv csillag filter
       */
      reviewStarFilter: '',
      /**
       * aktiv nyelv filter
       */
      reviewLangFilter: '',
      /**
       * kérdés írás folyamatban van-e
       */
      isWritingReview: false,
      /**
       * termék kérdés mentése folyamatban van-e
       */
      isReviewAddInProgress: false,
      /**
       * termék vélemény cime
       */
      reviewTitle: '',
      /**
       * termék vélemény szövege
       */
      reviewText: '',
      /**
       * választott csillag a vélemény irásához
       */
      selectedStarForReview: 0,
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'User/isLoggedIn',
      userId: 'User/getUserId',
    }),
    /**
     * valid-e a választott csillag a véleményhez
     */
    isSelectedStarValid() {
      return this.selectedStarForReview >= 1 && this.selectedStarForReview <= 5
    },
  },
  created() {
    this.loadReviewsMetaData()
    this.loadProductData()
    this.loadProductReviews()
  },
  mounted() {
    // $nextTick sem működött ezért kellet kis késleltetés
    setTimeout(() => {
      this.scrollToReviewBlockIfNeeded()
    }, 500)
  },
  methods: {
    /**
     * a vélemények lista vége látszik, töltjük a többi véleményt
     *
     * @param {boolean} isVisible
     */
    onListEndVisible(isVisible) {
      if (!isVisible || !this.isMoreReviewAvailable) {
        return
      }
      this.loadProductReviews()
    },
    /**
     * termék reviews meta adatokhoz lekérés
     */
    loadReviewsMetaData() {
      Axios.get('/Product/api/getReviewsMetaData', {
        params: {
          itemId: this.$route.params.id,
        },
      })
        .then(({ data }) => {
          this.metaData = data
        })
        .catch((e) => {
          console.error('loadReviewsMetaData', e)
          this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet'), NOTY_TYPE.NOTY_ERROR)
        })
    },
    /**
     * vélemény mentése
     */
    addReview() {
      const reviewText = this.reviewText.trim()
      if (reviewText === '' || !this.isSelectedStarValid || !this.isModerationAccepted) {
        this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet') + ': ' + this.$t('mm_toltsd_ki'), NOTY_TYPE.NOTY_ERROR)
        return
      }
      if (this.isReviewAddInProgress) {
        return
      }
      this.isReviewAddInProgress = true
      Axios.post('/Product/api/addReview', {
        itemId: this.$route.params.id,
        userId: this.userId,
        title: this.reviewTitle,
        review: reviewText,
        rating: this.selectedStarForReview,
      })
        .then(() => {
          this.isWritingReview = false
          this.reviewTitle = ''
          this.reviewText = ''
          this.selectedStarForReview = 0
          this.loadProductData()
          this.$root.$emit('notificationPush', this.$t('term_kosziavelemenyed'), NOTY_TYPE.NOTY_SUCCESS)
        })
        .catch((e) => {
          console.error('addQuestion', e)
          this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet'), NOTY_TYPE.NOTY_ERROR)
        })
        .finally(() => {
          this.isReviewAddInProgress = false
        })
    },
    /**
     * csillag választása véleményhez
     */
    selectStarForReview(star) {
      this.selectedStarForReview = star
    },
    /**
     * tudjuk-e váélasztani az adott csillagot filternek
     */
    canFilterCurrentStar(starCount) {
      if (this.reviewLangFilter === '') {
        return true
      }
      return this.availableStarFilterList.includes(starCount)
    },
    /**
     * tudjuk-e váélasztani az adott nyelvet filternek
     */
    canFilterCurrentLang(langKey) {
      if (this.reviewStarFilter === '') {
        return true
      }
      return this.availableLangFilterList.includes(langKey)
    },
    /**
     * vélemény forditása
     */
    translateReview(reviewId) {
      const reviewIndex = this.productReviewList.findIndex(review => review.ID === reviewId)
      this.$set(this.productReviewList[reviewIndex], 'isTranslationInProgress', true)
      Axios.get('/Portal/api/translateReview', {
        params: {
          reviewId: this.productReviewList[reviewIndex].ID,
          key: this.productReviewList[reviewIndex].key,
        },
      })
        .then(({ data }) => {
          this.$set(this.productReviewList[reviewIndex], 'needTranslation', false)
          this.$set(this.productReviewList[reviewIndex], 'hasTranslation', true)
          this.$set(this.productReviewList[reviewIndex], 'titleTranslation', data.title)
          this.$set(this.productReviewList[reviewIndex], 'reviewTranslation', data.text)
        })
        .catch((e) => {
          console.error('translateReview', e)
          this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet'), NOTY_TYPE.NOTY_ERROR)
        })
        .finally(() => {
          this.$set(this.productReviewList[reviewIndex], 'isTranslationInProgress', false)
        })
    },
    /**
     * vélemény hasznosság szavazat mentése
     */
    voteReview(params) {
      // if (this.isVoteInProgress) {
      //   return
      // }
      if (this.voteProgresses[params.reviewId] === true) {
        return
      }
      // this.isVoteInProgress = true
      this.$set(this.voteProgresses, params.reviewId, true)
      Axios.post('/Product/api/voteReview', params)
        .then(() => {
          const reviewIndex = this.productReviewList.findIndex(review => review.ID === params.reviewId)
          this.productReviewList[reviewIndex].isUserVoted = true
          this.productReviewList[reviewIndex].userVote = params.isUseful
          if (params.isUseful) {
            this.productReviewList[reviewIndex].r_useful++
          } else {
            this.productReviewList[reviewIndex].r_notuseful++
          }
          this.$root.$emit('notificationPush', this.$t('review_vote_thanks'), NOTY_TYPE.NOTY_SUCCESS)
        })
        .catch((e) => {
          console.error('voteReview', e)
          this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet'), NOTY_TYPE.NOTY_ERROR)
        })
        .finally(() => {
          // this.isVoteInProgress = false
          this.$set(this.voteProgresses, params.reviewId, false)
        })
    },
    /**
     * aktiv filterek reset
     */
    clearReviewFilters() {
      this.reviewStarFilter = ''
      this.reviewLangFilter = ''
      this.productReviewList = []
      this.loadProductReviews()
    },
    /**
     * nyelvi filter select
     */
    selectLangFilter(langKey) {
      if (this.reviewLangFilter === langKey) {
        this.reviewLangFilter = ''
      } else {
        this.reviewLangFilter = langKey
      }
      this.productReviewList = []
      this.loadProductReviews()
    },
    /**
     * csillag filter select
     */
    selectStarFilter(starCount) {
      if (this.reviewStarFilter === starCount) {
        this.reviewStarFilter = ''
      } else {
        this.reviewStarFilter = starCount
      }
      this.productReviewList = []
      this.loadProductReviews()
    },
    /**
     * termék adatok betöltése a lebegő termék cimkéhez és a user nem jováhagyott vélemények listája
     */
    loadProductData() {
      Axios.get('/Product/api/getDataForReviews', {
        params: {
          id: this.$route.params.id,
        },
      })
        .then(({ data }) => {
          this.product = data.product
          this.unAcceptedReviewList = data.unAcceptedReviewList
          this.productRateValue = data.productRateValue
          this.langFilterList = data.langFilterList
          this.reviewBarData = data.reviewBarData
          this.reviewCount = data.reviewCount
          document.title = data.title
        })
        .catch((e) => {
          console.error('loadProductData', e)
        })
    },
    /**
     * vélemények betöltése, lazy load, mindig fix mennyiséget tölt be, és hozzá füzzük az előzőleg betöltött listához
     */
    loadProductReviews() {
      this.isLoadInProgress = true
      Axios.get('/Product/api/getProductReviewList', {
        params: {
          id: this.$route.params.id,
          offset: this.productReviewList.length,
          reviewStarFilter: this.reviewStarFilter,
          reviewLangFilter: this.reviewLangFilter,
        },
      })
        .then(({ data }) => {
          this.productReviewList = [...this.productReviewList, ...data.productReviewList]
          this.isMoreReviewAvailable = data.isMoreReviewAvailable
          this.availableStarFilterList = data.availableStarFilterList
          this.availableLangFilterList = data.availableLangFilterList
        })
        .catch((e) => {
          console.error('loadProductReviews', e)
        })
        .finally(() => {
          this.isLoadInProgress = false
        })
    },
    /**
     * automatikusan lenyitja a véleményezés formot majd oda is navigál (scroll)
     */
    scrollToReviewBlockIfNeeded() {
      if (this.$route.query.opinion === undefined || this.$route.query.opinion !== 'open') {
        return
      }
      if (this.isLoggedIn) {
        this.isWritingReview = true
      }
      this.$nextTick(() => {
        let scrollElement
        // ha nincs belépve a user akkor belépés gombra kell a scroll
        // ha be vagyunk lépve akor pedig a vélemények formot nyitjuk fel és oda is scrollozunk
        if (this.isLoggedIn) {
          scrollElement = this.$refs.viewOpinion
        } else {
          scrollElement = this.$refs.loginToOpinion
        }
        window.scroll({
          // 160 px azért kell mert megjelenik a képernyő tetején egy termék banner (sticy-product-card) ami eltakarja a formot
          top: scrollElement.getBoundingClientRect().top - 160,
          left: 0,
          behavior: 'smooth',
        })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.page-title {
  font-weight: 800;
  font-size: 32px;
  line-height: 48px;
  text-transform: uppercase;

  @media screen and (max-width: 768px) {
    font-size: 24px;
    line-height: 32px;
  }
}

.new-review-block {
  textarea {
    width: 100%;
    min-height: 120px;
    resize: none;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ddd;
  }
}

hr {
  border: 1px solid #E5E5E5;
}
.review-page-btn {
  min-width: 50%;
}

.new-question-block {
  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }

  textarea {
    width: 100%;
    min-height: 120px;
    resize: none;
    padding: 10px;
  }
}

.load-more-btn {
  font-size: 14px;
  line-height: 16px;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
